// Tab configuration (you can easily add more types)
const JOB_TABS = [
  {
    key: 'inference-v2',
    label: 'Voice Swaps',
    fetchJobs: async (Api: any) => Api.fetchRecentInferenceJobs(),
    placeholder: 'Search by voice or filename...',
    title: 'Voice Swaps',
    viewAllPath: '/app/library/swaps',
    upgradeText: 'Upgrade for Unlimited Swaps',
    upgradePath: '/app/upgrade',
    toolPath: '/app/generate',
    instructions: [
      'Select a voice (either royalty-free or your own)',
      'Upload the audio you want to convert',
      "Choose whether it's a full song or just vocals",
      'Adjust pitch or other settings to customize the result if needed',
    ],
  },
  {
    key: 'stem-splitter',
    label: 'Stem Splits',
    fetchJobs: async (Api: any) => Api.fetchRecentStemSplitJobs(),
    placeholder: 'Search by stem or filename...',
    title: 'Stem Splits',
    viewAllPath: '/app/library/splits',
    upgradeText: 'Upgrade for Unlimited Splits',
    upgradePath: '/app/upgrade',
    toolPath: '/app/stem-splitter',
    instructions: [
      'Choose which stem you want to extract',
      'Upload the audio you want to split',
    ],
  },
  {
    key: 'lyrics-to-music',
    label: 'Style Sampler',
    fetchJobs: async (Api: any) => Api.fetchLyricsToMusicJobs(),
    placeholder: 'Search by voice or filename...',
    title: 'Samples',
    viewAllPath: '/app/library/samples',
    upgradeText: 'Upgrade for Unlimited Samples',
    upgradePath: '/app/upgrade',
    toolPath: '/app/text-to-song',
    instructions: [
      'Choose whether you want to generate a vocal track, choir or instrumental',
      'Select a style to sample by picking from community styles or uploading your own',
      "If it's not instrumental, enter your lyrics",
    ],
  },
  {
    key: 'song-generation',
    label: 'Song Generator',
    fetchJobs: async (Api: any) => Api.fetchRecentSongGenerationJobs(),
    placeholder: 'Search by song or filename...',
    title: 'Generated Songs',
    viewAllPath: '/app/library/generated-songs',
    upgradeText: 'Upgrade for Unlimited Songs',
    upgradePath: '/app/upgrade',
    toolPath: '/app/song-generator',
    instructions: [
      'Choose whether you want to generate a full song or an instrumental',
      'Write your lyrics',
      "Add a style if you'd like — this can be a voice, a music genre, or even a short text describing the vibe",
    ],
  },
];

// Function to filter tabs based on current route
export const getFilteredTabs = (pathname: string) => {
  // If we're on the song-generator page, show all tabs
  if (pathname.includes('/app/song-generator')) {
    return JOB_TABS;
  }

  // Otherwise, filter out the song-generation tab
  return JOB_TABS.filter(tab => tab.key !== 'song-generation');
};

export default JOB_TABS;
